import { makeStyles } from '@material-ui/core';

type StylesProps = {
  isMenuOpen: boolean;
};

const MENU_TEXT = '#EAF0F8';
const MENU_TEXT_ACTIVE = '#FFFFFF';
const MENU_HOVER = 'rgba(255, 255, 255, 0.1)';
const MENU_ACTIVE = 'rgba(36, 182, 141, 0.22)';
const MENU_ACTIVE_HOVER = 'rgba(36, 182, 141, 0.3)';

export default makeStyles(theme => ({
  list: {
    paddingBottom: 0,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1, 0),
    },
  },
  item: {
    '@media (hover: hover)': {
      '&:hover': {
        background: MENU_HOVER,
        color: MENU_TEXT_ACTIVE,
      },
    },
    color: MENU_TEXT,
    display: ({ isMenuOpen }: StylesProps) => (isMenuOpen ? 'flex' : 'none'),
    borderRadius: theme.shape.borderRadius,
    margin: theme.spacing(0.25, 0.5),
    paddingLeft: theme.spacing(1.5),
    transition: theme.transitions.create(['background-color', 'color', 'transform'], {
      duration: theme.transitions.duration.shorter,
    }),
    '&.Mui-focusVisible, &:focus-visible': {
      outline: `3px solid ${theme.palette.grey[300]}`,
      outlineOffset: 2,
      borderRadius: theme.shape.borderRadius,
      backgroundColor: MENU_HOVER,
    },
  },
  itemText: {
    '& span': {
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.125rem !important',
      },
    },
  },
  active: {
    color: MENU_TEXT_ACTIVE,
    background: MENU_ACTIVE,
    boxShadow: `inset 3px 0 0 ${theme.palette.secondary.main}`,
    '@media (hover: hover)': {
      '&:hover': {
        background: MENU_ACTIVE_HOVER,
        color: MENU_TEXT_ACTIVE,
      },
    },
  },
}));
